"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bignumber_1 = require("@ethersproject/bignumber");
function calculateGasMargin(value) {
    return value.mul(bignumber_1.BigNumber.from(10000 + 2000)).div(bignumber_1.BigNumber.from(10000));
}
exports.default = calculateGasMargin;
//# sourceMappingURL=calculateGasMargin.js.map